import { mapGetters, mapMutations } from 'vuex';
import { VUEX_GENERAL, VUEX_CHANGE_EXCESS } from '@/constants/VuexConstants';
import { convertToCurrencyString } from '@general/js/utils';
import { formatAsCurrency, formatToDisplayCurrencyPeriod } from '@/utils';
import { ProductExcessTypeCodes } from '@/enums';

export default {
  computed: {
    ...mapGetters({
      memberNumber: VUEX_GENERAL.GETTERS.getCurrentPolicyNumber,
      membershipInfo: VUEX_GENERAL.GETTERS.getMembershipInfo,
    }),

    ...mapGetters('ChangeExcess', {
      composition: VUEX_CHANGE_EXCESS.GETTERS.getComposition,
      eligibility: VUEX_CHANGE_EXCESS.GETTERS.getEligibility,
      currentExcess: VUEX_CHANGE_EXCESS.GETTERS.getCurrentExcess,
      excessType: VUEX_CHANGE_EXCESS.GETTERS.getExcessType,
      newExcess: VUEX_CHANGE_EXCESS.GETTERS.getNewExcess,
      excessOptions: VUEX_CHANGE_EXCESS.GETTERS.getExcessOptions,
      currentPremiumAndFrequency: VUEX_CHANGE_EXCESS.GETTERS.getCurrentPremiumAndFrequency,
      newPremiumAndFrequency: VUEX_CHANGE_EXCESS.GETTERS.getNewPremiumAndFrequency,
      currentPage: VUEX_CHANGE_EXCESS.GETTERS.getCurrentPage,
      submitPolicyInProcess: VUEX_CHANGE_EXCESS.GETTERS.getSubmitPolicyInProcess,
    }),

    excessChangeNotAllowed() {
      // Do not allow if excess option list is less than 1 in length
      return Array.isArray(this.excessOptions) && this.excessOptions.length < 1;
    },

    excessTypeText() {
      if (this.excessType === ProductExcessTypeCodes.MEMBER_EXCESS) {
        return 'adult';
      }

      if (this.excessType === ProductExcessTypeCodes.POLICY_EXCESS) {
        return 'policy';
      }

      return '';
    },
  },

  methods: {
    ...mapMutations('ChangeExcess', {
      updateComposition: VUEX_CHANGE_EXCESS.MUTATIONS.updateComposition,
      updateEligibility: VUEX_CHANGE_EXCESS.MUTATIONS.updateEligibility,
      updateCurrentExcess: VUEX_CHANGE_EXCESS.MUTATIONS.updateCurrentExcess,
      updateExcessType: VUEX_CHANGE_EXCESS.MUTATIONS.updateExcessType,
      updateNewExcess: VUEX_CHANGE_EXCESS.MUTATIONS.updateNewExcess,
      updateExcessOptions: VUEX_CHANGE_EXCESS.MUTATIONS.updateExcessOptions,
      updateCurrentPremiumAndFrequency: VUEX_CHANGE_EXCESS.MUTATIONS.updateCurrentPremiumAndFrequency,
      updateNewPremiumAndFrequency: VUEX_CHANGE_EXCESS.MUTATIONS.updateNewPremiumAndFrequency,
      updateCurrentPage: VUEX_CHANGE_EXCESS.MUTATIONS.updateCurrentPage,
      updateSubmitPolicyInProcess: VUEX_CHANGE_EXCESS.MUTATIONS.updateSubmitPolicyInProcess,
    }),

    convertToCurrencyString,
    formatAsCurrency,
    formatToDisplayCurrencyPeriod,
  },
};
